import { render, staticRenderFns } from "./BusinessPresentation.vue?vue&type=template&id=34eb493e&"
import script from "./BusinessPresentation.vue?vue&type=script&lang=js&"
export * from "./BusinessPresentation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPresentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports